var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentRequests = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5042 16.3154V11.2812L15.5979 2.375H4.71248C3.66267 2.375 2.65585 2.79204 1.91352 3.53437C1.17119 4.2767 0.75415 5.28352 0.75415 6.33333V30.0833C0.75415 31.1331 1.17119 32.14 1.91352 32.8823C2.65585 33.6246 3.66267 34.0417 4.71248 34.0417H14.9761C14.8534 33.4002 14.7598 32.7392 14.6976 32.0625H4.71248C4.18758 32.0625 3.68417 31.854 3.313 31.4828C2.94184 31.1116 2.73332 30.6082 2.73332 30.0833V6.33333C2.73332 5.80843 2.94184 5.30502 3.313 4.93385C3.68417 4.56269 4.18758 4.35417 4.71248 4.35417H15.5979V8.3125C15.5979 9.09986 15.9107 9.85497 16.4674 10.4117C17.0242 10.9685 17.7793 11.2812 18.5667 11.2812H22.525V16.3151C22.8496 16.2593 23.1796 16.2307 23.5138 16.2307C23.8485 16.2307 24.179 16.2594 24.5042 16.3154ZM5.70207 14.25C5.70207 13.7035 6.14512 13.2604 6.69165 13.2604H12.6292C13.1757 13.2604 13.6187 13.7035 13.6187 14.25C13.6187 14.7965 13.1757 15.2396 12.6292 15.2396H6.69165C6.14512 15.2396 5.70207 14.7965 5.70207 14.25ZM5.70207 20.1875C5.70207 19.641 6.14512 19.1979 6.69165 19.1979H15.5979C16.1444 19.1979 16.5875 19.641 16.5875 20.1875C16.5875 20.734 16.1444 21.1771 15.5979 21.1771H6.69165C6.14512 21.1771 5.70207 20.734 5.70207 20.1875ZM5.70207 26.125C5.70207 25.5785 6.14512 25.1354 6.69165 25.1354H13.6187C14.1653 25.1354 14.6083 25.5785 14.6083 26.125C14.6083 26.6715 14.1653 27.1146 13.6187 27.1146H6.69165C6.14512 27.1146 5.70207 26.6715 5.70207 26.125Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6582 33.0508H12.627",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 33.0508H15.5957",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5137 20.9792V14.25",
    stroke: "#3B3B3B",
    strokeWidth: 1.97917,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5498 36.8119V25.6494M23.5498 25.6494L18.7998 29.2119M23.5498 25.6494L28.2998 29.2119",
    stroke: "#3B3B3B",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentRequests);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document-requests.07a38c6c38c8b5ca05d80c9070cd5d21.svg";